module.exports = __webpack_public_path__ + "img/logo-harbour.974a1c84.jpg";